module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "List of Abbreviations"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "ch-5"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Contents#ch5"
    }
  }, [_c('b', [_vm._v("LIST OF ABBREVIATIONS")])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("AA")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Anti-Aircraft")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("ABDACOM")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("American, British, Dutch, and Australian Command; code name for Supreme Allied Headquarters South-West Pacific from 15 January 1942.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("AIF")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Australian Imperial Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("AIML")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("All India Muslim League")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("AOC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Air Officer Commanding")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("ARP")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Air Raid Precaution")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("A/T")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Antitank")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("AWM")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Australian War Memorial")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("BAR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Browning Automatic Rifle")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("BL")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("British Library")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("BOR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("British Other Rank")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("CAS")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Close Air Support")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("C3I")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Command, Control, Communications, and Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("CIGS")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Chief of the Imperial General Staff")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("CO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Commanding Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("CoSC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Chiefs of Staff Committee")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("CP")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Cabinet Papers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("EBO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Effects Based Operation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("ECIO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Emergency Commissioned Indian Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("ECO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Emergency Commissioned Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("FFR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Frontier Force Rifles")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("FOO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Forward Observation Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("GHQ")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("General Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("GOC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("General Officer Commanding")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("GoI")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Government of India")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("GR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Gurkha Rifles")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("GSO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("General Staff Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("ICO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Indian Commissioned Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("IIL")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Indian Independence League")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("IJA")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Imperial Japanese Army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("IJN")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Imperial Japanese Navy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("INA")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Indian National Army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("INC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Indian National Congress")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  }, [_vm._v("IOR")])]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("India Office Records")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("IWM")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Imperial War Museum")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("JAAF")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Japanese Army Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("JNAF")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Japanese Navy Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("KCIO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("King’s Commissioned Indian Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("LMG")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Light Machine Gun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("LoC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Line of Communication")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("MODHS")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Ministry of Defence Historical Section")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("MS")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Milestone")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("NAI")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("National Archives of India")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("NAM")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("National Army Museum")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("NCO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Noncommissioned Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("NMML")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Nehru Memorial Museum and Library")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("OIOC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Oriental and India Office Collection")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("OR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Other Rank/Private")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("OTU")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Officer Training Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("PoW")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Prisoner of War")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("PRO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Public Record Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("PWD")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Public Works Department")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RA")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Royal Artillery")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RAAF")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Royal Australian Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RAF")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Royal Air Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RE")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Royal Engineers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RGR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Royal Garwahl/Garhwal Rifles")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RN")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Royal Navy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("RR")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Rajputana Rifles")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("SLoC")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Sea Line of Communication")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "glo"
  }, [_vm._v("VCO")]), _vm._v(" "), _c('td', {
    staticClass: "glo1"
  }, [_vm._v("Viceroy’s Commissioned Officer")])])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "title": "xvii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 1: Far East Asia",
      "src": "images/map1.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap1"
    }
  }, [_vm._v("Map 1: Far East Asia")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xviii",
      "title": "xviii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 2: Proposed Sites for the Naval Base",
      "src": "images/map2.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap2"
    }
  }, [_vm._v("Map 2: Proposed Sites for the Naval Base")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xix",
      "title": "xix"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 3: Malaya",
      "src": "images/map3.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap3"
    }
  }, [_vm._v("Map 3: Malaya")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xx",
      "title": "xx"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 4: Japanese Advance in the Malayan Peninsula",
      "src": "images/map4.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap4"
    }
  }, [_vm._v("Map 4: Japanese Advance in the Malayan Peninsula")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxi",
      "title": "xxi"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 5: Japanese Attack on Northern Malaya, 7/8 December 1941",
      "src": "images/map5.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap5"
    }
  }, [_vm._v("Map 5: Japanese Attack on Northern Malaya, 7/8 December 1941")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxii",
      "title": "xxii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 6: Kota Bahru, 8 December 1941",
      "src": "images/map6.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap6"
    }
  }, [_vm._v("Map 6: Kota Bahru, 8 December 1941")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxiii",
      "title": "xxiii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 7: Jitra",
      "src": "images/map7.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap7"
    }
  }, [_vm._v("Map 7: Jitra")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxiv",
      "title": "xxiv"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 8: WESTFORCE Disposition in Johore, 14 January 1942",
      "src": "images/map8.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap8"
    }
  }, [_vm._v("Map 8: WESTFORCE Disposition in Johore, 14 January 1942")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxv",
      "title": "xxv"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 9: Northern Johore, 15 January 1942",
      "src": "images/map9.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap9"
    }
  }, [_vm._v("Map 9: Northern Johore, 15 January 1942")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxvi",
      "title": "xxvi"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 10: Johore Bahru, January 1942",
      "src": "images/map10.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap10"
    }
  }, [_vm._v("Map 10: Johore Bahru, January 1942")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxvii",
      "title": "xxvii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 11: Disposition of Troops on Singapore Island, 8 February 1942",
      "src": "images/map11.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap11"
    }
  }, [_vm._v("Map 11: Disposition of Troops on Singapore Island, 8 February 1942")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxviii",
      "title": "xxviii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 12: Japanese Attack, Singapore, February 1942",
      "src": "images/map12.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap12"
    }
  }, [_vm._v("Map 12: Japanese Attack, Singapore, February 1942")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxix",
      "title": "xxix"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "Map 13: The Japanese Assault and Advance and the Final Defense of the Perimeter, Singapore",
      "src": "images/map13.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps#rmap13"
    }
  }, [_vm._v("Map 13: The Japanese Assault and Advance and the Final Defense of the Perimeter, Singapore"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xxx",
      "title": "xxx"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c76455c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044174_Abbreviations.vue
// module id = 87
// module chunks = 0